import { useAppSelector } from "../../../utils/hooks";
import StarMessage from "../StarMessage/StarMessage";
import GroupInfo from "./GroupInfo";
import MediaLinksDocsTabs from "./MediaLinksDocsTabs";

export default function ConversationInfoDrawer() {
  const viewImageSlice = useAppSelector((state) => state.ViewManager);

  return (
    <div
      className={`fixed inset-y-0 right-0 z-50 flex h-[100dvh] w-full max-w-[100vw] flex-col overflow-hidden bg-secondary shadow-2xl transition-transform duration-300 ease-out lg:w-96 xl:w-[24rem] ${
        viewImageSlice?.showOtherProfile ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col">
        {viewImageSlice.showStarMessageList ? (
          <StarMessage />
        ) : viewImageSlice.showMediaDocLinks ? (
          <MediaLinksDocsTabs />
        ) : (
          <GroupInfo />
        )}
      </div>
    </div>
  );
}
